import client from "./axiosConfig";

export const getZohoTags = (params) => {
  const config = {
    url: "/users/zoho-tags/",
    method: "GET",
    params,
  };
  return client(config);
};

export const getZohoTagById = (id) => {
  const config = {
    url: `/users/zoho-tags/${id}/`,
    method: "GET",
  };
  return client(config);
};

export const getAllTagOptions = async (params) => {
  const response = await getZohoTags(params);
  const tags = response.data?.results || [];
  const options = tags.flatMap((tag) =>
    (tag.options || []).map((option) => ({
      ...option,
      tag_name: tag.tag_name,
    }))
  );
  return options;
};
